import { useState } from 'react';
import { buildContextFromState } from '../utils/contextData';

/**
 * Hook for managing template selector state and actions
 * Handles template selection dialog visibility and selection handling
 */
export function useTemplateSelector({ sendMessage, currentEncounter, currentPatient }) {
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);

  const handleTemplateSelect = (template) => {
    setShowTemplateSelector(false);
    // Build ai_context with template_id AND encounter/patient context
    // This ensures the backend state machine stays in the correct state
    const contextData = buildContextFromState(
      currentEncounter, 
      currentPatient, 
      { template_id: template.id }
    );
    sendMessage("TEMPLATE_SELECTED", null, contextData);
  };

  return {
    showTemplateSelector,
    setShowTemplateSelector,
    handleTemplateSelect
  };
}
